/**
 * Tooltip — wrapper léger qui ajoute un title HTML sur le 1er enfant (web uniquement).
 *
 * Sur web : le navigateur affiche une infobulle native au hover du bouton.
 * Sur iOS/Android : passthrough (pas de hover, donc pas de tooltip).
 *
 * Usage :
 *   <Tooltip text="Ouvrir le calendrier">
 *     <TouchableOpacity ...>
 *       <CalendarIcon />
 *     </TouchableOpacity>
 *   </Tooltip>
 */

import React, { useRef, useEffect } from 'react';
import { Platform } from 'react-native';

export default function Tooltip({ text, children }) {
  const innerRef = useRef(null);
  useEffect(() => {
    if (Platform.OS !== 'web' || !text) return;
    const node = innerRef.current;
    if (!node) return;
    try {
      // RN-web : la ref renvoie le HTMLElement sous-jacent
      const dom = node?.setAttribute ? node : null;
      if (dom) dom.setAttribute('title', String(text));
    } catch {}
  }, [text]);

  // Clone le 1er enfant et lui injecte une ref pour pouvoir attacher l'attribut.
  return React.cloneElement(React.Children.only(children), { ref: innerRef });
}
